export default __webpack_public_path__ + "static/media/entrance_11_1.0f522c45.png";